import PropTypes from 'prop-types';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import GoogleMapBody from './Body';

const View = ({ data, className }) => (
  <div className={cx('block', 'csjGoogleMap', className)}>
    <GoogleMapBody data={data} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

export default withBlockExtensions(View);
